module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.config.type == 'SelectTable') ? [(_vm.$store.state[_vm.config.storeName]) ? _c('l-table-view', {
    attrs: {
      "DataArr": _vm.$store.state[_vm.config.storeName],
      "TableConfig": _vm.config.tableConfig
    }
  }) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cfcf0eb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popover_item.vue
// module id = 1274
// module chunks = 169